import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/currency/exam_title.png'
import _imports_1 from '@/assets/currency/left.png'
import _imports_2 from '@/assets/currency/right.png'


const _withScopeId = n => (_pushScopeId("data-v-c92d2fc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dvBJ" }
const _hoisted_2 = { class: "dvContent" }
const _hoisted_3 = { class: "dvTop" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dvTopLeft" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dvTopLeftLogo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "dvTopLeftLogoImg",
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "dvTopLeftTitle ml1" }, "自由练习作答纪录")
], -1))
const _hoisted_5 = { class: "dvTopRightBtn" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "只看错题", -1))
const _hoisted_7 = { class: "dvSwitch ml1" }
const _hoisted_8 = { class: "dvMid" }
const _hoisted_9 = { class: "dvMidTop" }
const _hoisted_10 = {
  key: 0,
  class: "dvCoverNoList"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dvCoverNoTitle" }, "暂无记录!", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "dvCoverTitle mt8" }
const _hoisted_15 = { class: "dvCoverTitleDate" }
const _hoisted_16 = { class: "dvCoverBtn mt10" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "dvMidBottom" }
const _hoisted_19 = { class: "dvpage" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "dvImg",
  src: _imports_1
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "w50 colorF fontSize32" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "dvImg",
  src: _imports_2
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "dvBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.isErrorQuestion,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isErrorQuestion) = $event)),
              "active-color": "#d3142a",
              "inactive-color": "#B0B1B1",
              onChange: _ctx.checkIsErrorQuestion
            }, null, 8, ["modelValue", "onChange"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_ctx.subjectInfo.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.subjectInfoEight, (question, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: ($event: any) => (_ctx.goToSubject(question.FPSubmitDate)),
                  class: "dvCoverList",
                  key: question.FPSubmitDate,
                  style: _normalizeStyle({
              marginLeft: [0, 4].includes(index) ? '1%' : '2%',
              marginTop: index > 3 ? '2%' : '',
            })
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.questionType[question.type]), 1),
                    (question.AnswerIsSuccess)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          style: _normalizeStyle({
                  backgroundColor: question.AnswerIsSuccess
                    ? '#5ecd7e'
                    : ' #d3142a',
                }),
                          class: "dvCoverTitleBtn"
                        }, _toDisplayString(question.AnswerIsSuccessText), 5))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          style: _normalizeStyle({
                  backgroundColor: question.AnswerIsSuccess
                    ? '#5ecd7e'
                    : ' #d3142a',
                }),
                          class: "dvCoverTitleBtn"
                        }, _toDisplayString(question.AnswerIsSuccessText), 5))
                  ]),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(question.FPSubmitDate), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                      class: "btnStartExam",
                      onClick: ($event: any) => (_ctx.goToSubject(question.FPSubmitDate))
                    }, " 查看详情 ", 8, _hoisted_17)
                  ])
                ], 12, _hoisted_13))
              }), 128))
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", {
              class: "dvIcon",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previous && _ctx.previous(...args)))
            }, _hoisted_21),
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.current_page) + " / " + _toDisplayString(_ctx.total), 1),
            _createElementVNode("div", {
              class: "dvIcon",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
            }, _hoisted_24)
          ])
        ], 512), [
          [_vShow, _ctx.subjectInfo.length > 0]
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("button", {
          class: "btnBack",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, "返 回")
      ])
    ])
  ]))
}